import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';

import { KnBrCustomerHeaderComponent } from './kn-br-customer-header.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgSelectModule,
        PageComponentModule,
        PageLayoutModule,
        PageSlotModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrPurchasingAgentHeaderComponent: {
                    component: KnBrCustomerHeaderComponent,
                },
            },
        } as CmsConfig),
        KnBrCustomerHeaderComponent,
    ],
    exports: [KnBrCustomerHeaderComponent],
})
export class KnBrCustomerHeaderModule {}
